export default {
  data() {
    return {
      templatesDropdownData: {
        mobileDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortTemplates(
                    this.teamsSettings[this.$route.params.team].listsSettings.templates.order.col,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortTemplates(
                    this.teamsSettings[this.$route.params.team].listsSettings.templates.order.col,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
          {
            title: this.$t("dropdowns.sortingBy"),
            options: [
              {
                label: this.$t("template.name"),
                key: "name",
                method: () => {
                  this.sortTemplates(
                    "name",
                    this.teamsSettings[this.$route.params.team].listsSettings.templates.order.dir
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("template.locale"),
                key: "locale",
                method: () => {
                  this.sortTemplates(
                    "locale",
                    this.teamsSettings[this.$route.params.team].listsSettings.templates.order.dir
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("template.created_at"),
                key: "created_at",
                method: () => {
                  this.sortTemplates(
                    "created_at",
                    this.teamsSettings[this.$route.params.team].listsSettings.templates.order.dir
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("template.updated_at"),
                key: "updated_at",
                method: () => {
                  this.sortTemplates(
                    "updated_at",
                    this.teamsSettings[this.$route.params.team].listsSettings.templates.order.dir
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        sortMainColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            key: "name",
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortTemplates("name", "ASC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortTemplates("name", "DESC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        showAsFirstColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            disabled: false,
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortTemplates(
                    this.teamsSettings[this.$route.params.team].listsSettings.templates.showAs.firstCol.key,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortTemplates(
                    this.teamsSettings[this.$route.params.team].listsSettings.templates.showAs.firstCol.key,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
            ],
          },
          {
            title: this.$t("dropdowns.showAs"),
            options: [
              {
                label: this.$t("template.locale"),
                key: "owner",
                method: () => {
                  this.changeCol({
                    list: "templates",
                    showAs: {
                      firstCol: {
                        label: "template.locale",
                        key: "locale",
                        format: "locale",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("template.theme"),
                key: "theme",
                method: () => {
                  this.changeCol({
                    list: "templates",
                    showAs: {
                      firstCol: {
                        label: "template.theme",
                        key: "theme",
                        format: "theme",
                        size: 1,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("template.created_at"),
                key: "created_at",
                method: () => {
                  this.changeCol({
                    list: "templates",
                    showAs: {
                      firstCol: {
                        label: "template.created_at",
                        key: "created_at",
                        format: "dateFromNow",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("template.updated_at"),
                key: "updated_at",
                method: () => {
                  this.changeCol({
                    list: "templates",
                    showAs: {
                      firstCol: {
                        label: "template.updated_at",
                        key: "updated_at",
                        format: "dateFromNow",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        showAsSecondColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            disabled: false,
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortTemplates(
                    this.teamsSettings[this.$route.params.team].listsSettings.templates.showAs.secondCol.key,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortTemplates(
                    this.teamsSettings[this.$route.params.team].listsSettings.templates.showAs.secondCol.key,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
            ],
          },
          {
            title: this.$t("dropdowns.showAs"),
            options: [
              {
                label: this.$t("template.locale"),
                key: "owner",
                method: () => {
                  this.changeCol({
                    list: "templates",
                    showAs: {
                      secondCol: {
                        label: "template.locale",
                        key: "locale",
                        format: "locale",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
              },
              {
                label: this.$t("template.theme"),
                key: "theme",
                method: () => {
                  this.changeCol({
                    list: "templates",
                    showAs: {
                      secondCol: {
                        label: "template.theme",
                        key: "theme",
                        format: "theme",
                        size: 1,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("template.created_at"),
                key: "created_at",
                method: () => {
                  this.changeCol({
                    list: "templates",
                    showAs: {
                      secondCol: {
                        label: "template.created_at",
                        key: "created_at",
                        format: "dateFromNow",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("template.updated_at"),
                key: "updated_at",
                method: () => {
                  this.changeCol({
                    list: "templates",
                    showAs: {
                      secondCol: {
                        label: "template.updated_at",
                        key: "updated_at",
                        format: "dateFromNow",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        showAsThirdColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            disabled: false,
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortTemplates(
                    this.teamsSettings[this.$route.params.team].listsSettings.templates.showAs.thirdCol.key,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortTemplates(
                    this.teamsSettings[this.$route.params.team].listsSettings.templates.showAs.thirdCol.key,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
            ],
          },
          {
            title: this.$t("dropdowns.showAs"),
            options: [
              {
                label: this.$t("template.locale"),
                key: "owner",
                method: () => {
                  this.changeCol({
                    list: "templates",
                    showAs: {
                      thirdCol: {
                        label: "template.locale",
                        key: "locale",
                        format: "locale",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("template.theme"),
                key: "theme",
                method: () => {
                  this.changeCol({
                    list: "templates",
                    showAs: {
                      thirdCol: {
                        label: "template.theme",
                        key: "theme",
                        format: "theme",
                        size: 1,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("template.created_at"),
                key: "created_at",
                method: () => {
                  this.changeCol({
                    list: "templates",
                    showAs: {
                      thirdCol: {
                        label: "template.created_at",
                        key: "created_at",
                        format: "dateFromNow",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("template.updated_at"),
                key: "updated_at",
                method: () => {
                  this.changeCol({
                    list: "templates",
                    showAs: {
                      thirdCol: {
                        label: "template.updated_at",
                        key: "updated_at",
                        format: "dateFromNow",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        filterDropdown: [
          {
            title: this.$t("filters.filterTemplates"),
            options: [
              {
                label: this.$t("filters.withLocale"),
                select: {
                  name: "with_locale",
                  multiple: true,
                  model: null,
                  options: [],
                  label: "label",
                  placeholder: this.$t("placeholders.selectLocale"),
                  wrap: true,
                  searchable: true,
                  searchChange: () => {},
                },
                method: () => {},
                checkbox: true,
                hoverBg: true,
                hideIfNoOptions: true,
              },
              {
                label: this.$t("filters.withoutLocale"),
                select: {
                  name: "without_locale",
                  multiple: true,
                  model: null,
                  options: [],
                  label: "label",
                  placeholder: this.$t("placeholders.selectLocale"),
                  wrap: true,
                  searchable: true,
                  searchChange: () => {},
                },
                method: () => {},
                checkbox: true,
                hoverBg: true,
                hideIfNoOptions: true,
              },
              {
                label: this.$t("filters.withTheme"),
                select: {
                  name: "with_theme",
                  multiple: true,
                  model: [],
                  options: [],
                  label: "label",
                  placeholder: this.$t("placeholders.selectTheme"),
                  wrap: true,
                  searchable: true,
                  searchChange: () => {},
                },
                method: () => {},
                checkbox: true,
                hoverBg: true,
                hideIfNoOptions: true,
              },
              {
                label: this.$t("filters.withoutTheme"),
                select: {
                  name: "without_theme",
                  multiple: true,
                  model: [],
                  options: [],
                  label: "label",
                  placeholder: this.$t("placeholders.selectTheme"),
                  wrap: true,
                  searchable: true,
                  searchChange: () => {},
                },
                method: () => {},
                checkbox: true,
                hoverBg: true,
                hideIfNoOptions: true,
              },
              {
                label: this.$t("filters.activateFilter"),
                border: "border-top",
                color: "primary",
                position: "center",
                method: () => {
                  this.setTemplatesFilters();
                },
                noActiveState: true,
                button: true,
              },
              {
                label: this.$t("filters.resetFilter"),
                color: "text-danger",
                position: "center",
                method: () => {
                  this.resetFilters(this.setTemplatesFilters);
                },
                hoverBg: true,
                noActiveState: true,
              },
            ],
          },
        ],
      },
    };
  },
};
